<template>
  <div class="order">
    <van-tabs
      v-model="active"
      sticky
      swipeable
      color="#00BC7A"
      @change="tabChange"
      v-if="userId"
    >
      <!-- 预约说明 -->
      <van-tab title="预约说明">
        <div class="sysArticleInfo" v-if="appointText">
          <div v-html="appointText"></div>
        </div>
        <div style="height: 5rem;" v-if="orderData.length"></div>
      </van-tab>
      <!-- 预约记录 -->
      <van-tab title="预约记录">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            :finished-text="finishedText"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
          >
            <template v-if="orderData.length">
              <div
                class="list"
                v-for="item in orderData"
                :key="item.orderId"
                @click="orderDetailGo(item)"
              >
                <div class="name-tool">
                  <span class="name van-ellipsis">{{ item.scenicName }}</span>
                  <span
                    class="tool"
                    v-if="item.orderStatus == 0"
                    @click.stop="cancalOrder(item)"
                    >取消预约</span
                  >
                  <span class="tool" v-if="item.orderStatus == 1"
                    >查看票务</span
                  >
                </div>
                <ul class="items">
                  <li class="item">
                    <span class="label">预约人</span>
                    <span class="text">{{ userInfo.name }}</span>
                  </li>
                  <li class="item">
                    <span class="label">预约日期</span>
                    <span class="text">{{ item.appointDay }}</span>
                  </li>
                  <li class="item">
                    <span class="label"></span>
                    <span class="text"></span>
                  </li>
                </ul>
                <img
                  class="status"
                  :src="picUrl + 'qunaer/order/orderStatus00.png'"
                  alt=""
                  srcset=""
                  v-if="item.orderStatus == 0"
                />
                <img
                  class="status"
                  :src="picUrl + 'qunaer/order/orderStatus01.png'"
                  alt=""
                  srcset=""
                  v-if="item.orderStatus == 1"
                />
                <img
                  class="status"
                  :src="picUrl + 'qunaer/order/orderStatus02.png'"
                  alt=""
                  srcset=""
                  v-if="item.orderStatus == 2"
                />
                <img
                  class="status"
                  :src="picUrl + 'qunaer/order/orderStatus03.png'"
                  alt=""
                  srcset=""
                  v-if="item.orderStatus == 3"
                />
              </div>
            </template>
          </van-list>
          <div style="height: 5rem;" v-if="orderData.length"></div>
        </van-pull-refresh>
        <template v-if="!orderData.length && !loading && !error">
          <img
            class="nocard-pic"
            :src="picUrl + 'qunaer/order/nocard.png'"
            alt=""
            srcset=""
          />
          <p class="nocard-text">您还没有预约，赶快去预约吧～</p>
        </template>
      </van-tab>
    </van-tabs>
    <van-tabbar
      v-model="tabbarActive"
      active-color="#00BC7A"
      inactive-color="#999"
      @change="tabbarChange"
    >
      <van-tabbar-item>
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? icon[0].active : icon[0].inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="search">
        <span>预约</span>
        <template #icon="props">
          <img :src="props.active ? icon[1].active : icon[1].inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import {
  Tab,
  Tabs,
  Tabbar,
  TabbarItem,
  PullRefresh,
  List,
  Toast,
  Dialog,
} from "vant"

import tabbar00 from "./../assets/tabbar/tabbar00.png"
import tabbar00_ from "./../assets/tabbar/tabbar00_.png"
import tabbar01 from "./../assets/tabbar/tabbar01.png"
import tabbar01_ from "./../assets/tabbar/tabbar01_.png"

import { getPicUrl, setToken } from '@/utils/auth'
import { getUserInfo, queryByBusinessId, cancelOrder, AppointmentText } from '@/api/index'

export default {
  name: "Order",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      picUrl: getPicUrl(),
      userInfo: {},
      userId: "",
      active: 1,
      loading: true,
      finished: false,
      error: false,
      refreshing: false,
      finishedText: "",
      orderData: [],
      pageNum: 0,
      pageSize: 20,
      pageTotal: 0,
      tabbarActive: 1,
      latitude: "",
      longitude: "",
      icon: [
        {
          active: tabbar00,
          inactive: tabbar00_,
        },
        {
          active: tabbar01,
          inactive: tabbar01_,
        },
      ],
      appointText: null
    };
  },
  created() {
    const that = this;
    this.businessId = this.$route.params.businessId;
    this.getUserInfo()
      .then((res) => {
        if (res.data.code != "200") {
          throw res.data.msg;
        }
        if (res.data.code == "200") {
          setToken(res.data.data.token)
          that.userInfo = res.data.data
          that.userId = res.data.data.userId
          that.tabChange(that.active)
        }
      })
      .catch((error) => {
        this.$toast(error)
      })
      that.getAppointmentText()
  },
  methods: {
    // tab切换
    tabChange(index) {
      if (index == 1) {
        this.onRefresh()
      }
    },
    // tabbar切换
    tabbarChange(index) {
      if (index == 0) {
        this.$router.push({
          name: "Home",
          params: { businessId: this.businessId }
        })
      }
    },
    // 预约记录
    order() {
      const that = this;
      const { pageNum, pageSize, businessId, latitude, longitude } = this
      const overdueStatus = 0
      queryByBusinessId({ pageNum, pageSize, businessId, latitude, longitude, overdueStatus })
        .then(function(res) {
          if (that.refreshing) {
            that.refreshing = false
          }
          if (res.data.code != "200") {
            throw res.data.msg
          }
          if (res.data.code == "200") {
            const total = res.data.data.total
            let listData = []
            if (that.pageNum < 2) {
              listData = res.data.data.list || []
              document.documentElement.scrollTop = 0
            }
            if (that.pageNum > 1) {
              listData = that.orderData.concat(res.data.data.list)
            }

            that.orderData = listData

            // 加载状态结束
            that.loading = false

            // 数据全部加载完成
            if (listData.length >= total) {
              that.finished = true
              that.finishedText = listData.length ? "已经到底了" : ""
            }
          }
        })
        .catch(() => {
          that.loading = false
          that.error = true
          that.pageNum = that.pageNum - 1
        })
    },
    // 预约记录翻页
    onLoad() {
      this.finishedText = this.pageNum < 1 ? "" : "已经到底了"
      this.pageNum = this.pageNum + 1
      this.order()
    },
    // 预约记录下拉刷新
    onRefresh() {
      this.pageNum = 0
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    // 获取预约说明
    getAppointmentText() {
      const that = this;
      AppointmentText({ businessId:this.businessId, articleId: '2' })
        .then(function(res) {
          if (res.data.code != "200") {
            throw res.data.msg
          }
          if (res.data.code == "200") {
            that.appointText = res.data.data.articleDetails

            // 加载状态结束
            that.loading = false
          }
        })
        .catch(() => {
          that.loading = false
          that.error = true
        })
    },
    // 富文本转换
    replaceDetail: function(details) {
      var texts = ""; //待拼接的内容
      while (details.indexOf("<img") != -1) {
        //寻找img 循环
        texts += details.substring("0", details.indexOf("<img") + 4); //截取到<img前面的内容
        details = details.substring(details.indexOf("<img") + 4); //<img 后面的内容
        if (
          details.indexOf("style=") != -1 &&
          details.indexOf("style=") < details.indexOf(">")
        ) {
          texts +=
            details.substring(0, details.indexOf('style="') + 7) +
            "max-width:100%;height:auto;margin:0 auto;"; //从 <img 后面的内容 截取到style= 加上自己要加的内容
          details = details.substring(details.indexOf('style="') + 7); //style后面的内容拼接
        } else {
          texts += ' style="max-width:100%;height:auto;margin:0 auto;" ';
        }
      }
      texts += details; //最后拼接的内容
      return texts;
    },
    // 获取用户信息
    getUserInfo() {
      const businessId = this.businessId
      return getUserInfo({ businessId })
    },
    // 订单详情
    orderDetailGo(item) {
      this.$router.push({
        name: "OrderDetail",
        params: { businessId: this.businessId, orderId: item.orderId }
      })
    },
    
    // 取消预约询问
    cancalOrder(item) {
      const that = this
      const { userId } = this
      const orderId = item.orderId
     
      this.$dialog
        .confirm({
          message: "确定取消该预约？"
        })
        .then(() => {
          that.cancalOrderGo(orderId, userId)
        }).catch()
    },
    // 取消预约
    async cancalOrderGo(orderId, userId) {
      const res = await cancelOrder({orderId, userId})
      if (res.data.code != "200") {
        this.$toast.clear();
        this.$toast(res.data.msg)
        this.pageNum = 0
        this.loading = false
        this.error = true
      }
      if (res.data.code == "200") {
        this.$toast.clear()
        this.tabChange(this.active)
      }
    }
  }
}
</script>

<style scoped>
/* 预约说明 */
.sysArticleInfo {
  padding: 30px;
  width: calc(100% - 60px);
  font-size: 22px;
  line-height: 55px;
  color: #666;
}
/* 预约列表 */
.list {
  position: relative;
  margin: 30px auto;
  box-shadow: 0px 0px 40px 0px rgba(216, 216, 216, 0.5);
  border-radius: 20px;
  padding: 30px;
  width: calc(100% - 120px);
  height: 200px;
  background: #fff;
}
.list .name-tool {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.list .name-tool .name {
  flex: 0 1 auto;
  height: 50px;
  font-size: 36px;
  font-weight: bold;
  line-height: 50px;
}
.list .name-tool .tool {
  flex: 0 0 auto;
  border-radius: 6px;
  border: 2px solid #00bc7a;
  width: 120px;
  height: 50px;
  font-size: 24px;
  line-height: 54px;
  text-align: center;
  color: #00bc7a;
}
.list .items {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  width: 100%;
  font-size: 24px;
}
.list .items .item {
  display: flex;
  flex-direction: column;
}
.list .items .label,
.list .items .text {
  height: 33px;
  font-size: 24px;
  line-height: 33px;
}
.list .items .label {
  margin-bottom: 10px;
  color: #999;
}
.list .status {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 160px;
  height: 160px;
}
.nocard-pic {
  display: block;
  margin: 70px auto 10px auto;
  width: 400px;
  height: 400px;
}
.nocard-text {
  height: 40px;
  font-size: 28px;
  line-height: 40px;
  text-align: center;
  color: #999;
}
</style>
